import React from "react";
import Select from "react-dropdown-select";
import { icons } from "../../../assets/icons";

const SelectInput = ({
  id = "",
  title = "",
  options = [],
  value = "",
  error,
  required,
  onChange = () => {},
  disabled = false,
  wrapperClassName = "",
  labelClassName,
  selectClassName = "",
  renderRight,
  labelField = "key",
  valueField = "value",
  onChangeFullRes = false,
}) => {
  return (
    <span className={`flex flex-col ${wrapperClassName}`}>
      {title ? (
        <label
          htmlFor={id}
          className={`font-size-small text-[var(--blackColor)] ${labelClassName}`}
        >
          {title}
          {required ? <span className="text-[#e55353]"> *</span> : null}
        </label>
      ) : null}

      <Select
        dropdownHandleRenderer={() => {
          if (renderRight) {
            return renderRight();
          }
          return (
            <img
              src={icons.arrowDown}
              alt="arrow down"
              className="w-[1.2rem]"
            />
          );
        }}
        options={options}
        onChange={(e) => (onChangeFullRes ? onChange(e) : onChange(e[0]?.value))}
        labelField={labelField}
        valueField={valueField}
        name="select"
        disabled={disabled}
        searchable={false}
        values={
          value
            ? [{ key: value, value }]
            : [options?.[0] || { key: "Please Select", value: "" }]
        }
        style={{
          borderRadius: '4px'
        }}
        className={`min-w-[100%] h-[5rem] border-[1px] border-[var(--borderGray1)] bg-[var(--whiteColor)] px-4 text-[16px] text-[var(--textGray2)] mt-2 pr-12 ${selectClassName}`}
      />

      {error ? (
        <div className={`font-size-small text-[var(--textRed)] mt-2`}>
          {error}
        </div>
      ) : null}
    </span>
  );
};

export default SelectInput;
